import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (location.params && location.params.id) {
      getBook();
    } else {
      history.push('/book');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getBook = () => {
    AxiosInstance.get('/book/' + location.params.id)
      .then((response) => {
        let inputValues = {
          ISBN: response.data.ISBN,
          authors: response.data.authors,
          categories: response.data.categories,
          title: response.data.title,
          cover: response.data.cover,
          pdf: response.data.pdf,
          summary: response.data.summary,
          abstract: response.data.abstract,
          editionNumber: response.data.editionNumber,
          publicationNumber: response.data.publicationNumber,
          publishingHouse: response.data.publishingHouse,
          releaseDate: response.data.releaseDate,
          pages: response.data.pages,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('book.ERROR_GET_BOOK'), '', 'error');
        // history.push('/book');
      });
  };

  const updateBook = () => {
    return;
  };

  const inputValues = {
    ISBN: { value: '', validate: { required: true } },
    authors: { value: '', validate: { required: false } },
    categories: { value: '', validate: { required: false } },
    title: { value: '', validate: { required: false } },
    cover: { value: '', validate: { required: false } },
    pdf: { value: '', validate: { required: false } },
    summary: { value: '', validate: { required: false } },
    abstract: { value: '', validate: { required: false } },
    editionNumber: { value: '', validate: { required: false } },
    publicationNumber: { value: '', validate: { required: false } },
    publishingHouse: { value: '', validate: { required: false } },
    releaseDate: { value: '', validate: { required: false } },
    pages: { value: '', validate: { required: false } },
  };

  const { updateFormState, field, formState } = FormState(inputValues, updateBook);

  return {
    back,
    field,
    formState,
  };
};

export default useForm;
